// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9e5118aa","977":"2150cab5"}[chunkId] + ".chunk.js";
};